/*
	Bootstrap 4 Mega Dropdown Menu (https://mm-united.com) Copyright 2016 - 2018 MM United. All Rights Reserved.
	Licensed under Regular License (http://codecanyon.net/licenses/regular) or Extended License (http://codecanyon.net/licenses/extended)
	We will take legal action against those who copy our HTML content, CSS style sheets and JavaScript functions without a license.
*/


// Commom s
(function($) {

	'use strict';

	if ($.isFunction($.fn['matchHeight'])) {
		$('.match-height').matchHeight();
	}
}).apply(this, [jQuery]);

// Animate
(function($) {

	'use strict';

	if ($.isFunction($.fn['mdmAnimate'])) {
		$(function() {
			$('[data-appear-animation]').each(function() {
				var $this = $(this),
					opts;

				var Options = mdm.fn.getOptions($this.data('-options'));
				if (Options)
					opts = Options;

				$this.mdmAnimate(opts);
			});
		});
	}
}).apply(this, [jQuery]);

// Match Height
(function($) {

	'use strict';

	if ($.isFunction($.fn['mdmMatchHeight'])) {
		$(function() {
			$('[data--match-height]:not(.manual)').each(function() {
				var $this = $(this),
					opts;

				var Options = mdm.fn.getOptions($this.data('-options'));
				if (Options)
					opts = Options;

				$this.mdmMatchHeight(opts);
			});
		});
	}
}).apply(this, [jQuery]);

// Sticky
(function($) {

	'use strict';

	if ($.isFunction($.fn['mdmSticky'])) {
		$(function() {
			$('[data--sticky]:not(.manual)').each(function() {
				var $this = $(this), opts;
				var Options = mdm.fn.getOptions($this.data('-options'));
				if (Options) opts = Options;
				$this.mdmSticky(opts);
			});
		});
	}
}).apply(this, [jQuery]);

// Burger Icon
(function($){
	
	'use strict';
	
  var burger = document.querySelector('.header-btn-collapse-nav'),
    header = document.querySelector('.header-nav');
    
    burger.onclick = function() {
      header.classList.toggle('menu-opened');
    }
}).apply(this, [jQuery]);

// Commom partials
(function($) {

	'use strict';

	// Sticky Header
	if (typeof mdm.StickyHeader !== 'undefined') {
		mdm.StickyHeader.initialize();
	}

	// Burger menu
	if (typeof mdm.BurgerIcon !== 'undefined') {
		mdm.BurgerIcon.initialize();
	}

	// Nav menu
	if (typeof mdm.Nav !== 'undefined') {
		mdm.Nav.initialize();
	}
}).apply(this, [jQuery]);